<div class="grid grid-nogutter w-full h-fit max-h-full">
  <section class="col-9 pr-3 flex flex-column gap-2">
    <h5 class="text-base m-0 font-bold line-height-1">{{ item().title | translate }}</h5>
    <span class="hidden text-sm">
                    Ver, crear, actualizar, eliminar y dar soportesocios comerciales y clientes directos.
                  </span>
    <span class="text-sm">
                    {{ item().data.description | translate }}
                  </span>
  </section>
  <section class="col-3 text-center h-full">
                  <span class="icon_inline grid__center my-0 mx-auto">
                      <i [class]="'m-2 far fa-'+item().icon"></i>
                  </span>
  </section>
</div>
<div class="float_el overflow-hidden w-10 h-full">
  <div class="icon_bg flex justify-content-center align-content-start">
    <i [class]="'block mt-4 mx-4 far fa-'+item().icon"></i>
  </div>
</div>
